import { makeStyles } from "@material-ui/core";
import useTranslation from "next-translate/useTranslation";
import React, { FC } from "react";
import { TheCycleverseTheme } from "src/theme";

const useStyles = makeStyles((theme: TheCycleverseTheme) => ({
  resultContainer: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: "10px",
  },

  resultText: {
    padding: "5px",
  },

  result: {
    color: theme?.greenColor,
    padding: "5px",
    fontWeight: 500,
  },

  resultWithTwoTextWidth: {
    width: "100%",
  },

  resultTextWidth: {
    width: "60%",
  },

  resultWidth: {
    width: "35%",
  },
}));

type Results = {
  texta?: string;
  resulta?: string;
  resultb?: string;
  textb?: string;
  backgroundColor?: string;
};

export const DisplayResult: FC<Results> = ({ texta, resulta, resultb, backgroundColor }) => {
  const classes = useStyles();
  const { t } = useTranslation("fahrradVvsAutoRechner");
  return (
    <div className={classes?.resultContainer}>
      <div className={`${classes.resultText} ${classes.resultTextWidth} ${backgroundColor}`}>{texta}</div>
      <div className={`${classes.result} ${classes?.resultWidth} ${backgroundColor}`}>
        <span>{resulta}</span>{" "}
        {resultb ? (
          <>
            <span>{t("and")}</span> <span>{resultb}</span>
          </>
        ) : null}
      </div>
    </div>
  );
};

export const DisplayResultWithTwoText: FC<Results> = ({ texta, resulta, textb, backgroundColor }) => {
  const classes = useStyles();
  return (
    <div className={classes?.resultContainer}>
      <div className={`${classes.resultText} ${classes.resultWithTwoTextWidth} ${backgroundColor}`}>
        <span>{texta}</span> <span className={`${classes.result} ${backgroundColor}`}>{resulta}</span>{" "}
        <span>{textb}</span>
      </div>
    </div>
  );
};

export const DisplayResultFirst: FC<Results> = ({ texta, resulta, backgroundColor }) => {
  const classes = useStyles();
  return (
    <div className={classes?.resultContainer}>
      <div className={`${classes.resultText} ${classes.resultWithTwoTextWidth} ${backgroundColor}`}>
        <span className={`${classes.result} ${backgroundColor}`}>{resulta}</span> <span>{texta}</span>
      </div>
    </div>
  );
};
